import { ComponentProps } from 'react';

import { LoadingButton, Tooltip } from '@ingrid/luterkort-react';

import { ConditionalWrapper } from '~src/components/ConditionalWrapper/ConditionalWrapper';
import { useTranslation } from '~src/i18n/use-translation';

import { useShipmentActions } from '../hooks';
import { useMergeLabelsMutation } from '../mutations';
import { ShipmentDetails } from '../types';

interface Props {
  shipment: Pick<ShipmentDetails, 'direction_type' | 'status' | 'deliveries'>;
  size?: ComponentProps<typeof LoadingButton>['size'];
}

export function DownloadConsolidatedLabelButton(props: Props) {
  const { shipment, size } = props;

  const actions = useShipmentActions({
    shipment: { direction_type: shipment.direction_type, status: shipment.status?.type },
  });

  const isDisabled = !actions.includes('PRINT_LABEL');
  const labelUrls = shipment.deliveries.map(d => d.label_url!);
  const mutation = useMergeLabelsMutation();

  const { t } = useTranslation();

  async function handleDownload() {
    const { data } = await mutation.mutateAsync({ labelUrls });
    window.open(data.url);
  }

  return (
    <ConditionalWrapper
      when={isDisabled}
      wrapper={c => (
        <Tooltip content={t('shipment.details.notPrintable')}>
          <span>{c}</span>
        </Tooltip>
      )}
    >
      <LoadingButton
        loading={mutation.isPending}
        onClick={handleDownload}
        disabled={isDisabled}
        variant="secondary"
        size={size}
      >
        {t('shipments.details.downloadConsolidatedLabel')}
      </LoadingButton>
    </ConditionalWrapper>
  );
}
